import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {OmsDialogService} from "../../../oms/services/oms-dialog-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {OmsOrderStatusType} from "../../../oms/types/oms-order-status.type";

export class AccountActiveOrdersComponent implements IController {

  account: AccountModel;
  isDemand: boolean;

  public loadLimit: number;
  public omsOrdersRef: any;
  public infiniteScroll: any;
  public selectedIds: any;
  public excludeMode: boolean;
  public defaultGroup: any;
  public filterConfig: any;
  public isSmallScreen: boolean;
  public activeStatuses: OmsOrderStatusType | string[];
  public omsOrderStatusType: typeof OmsOrderStatusType = OmsOrderStatusType;

  constructor(private $log, private $omsOrder, private deliveriesConstants, private splitService: SplitService, private omsDialogService: OmsDialogService,
              private $infiniteScroll, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $mdMedia, public omsService: OmsService) {
  }

  $onInit() {


    this.activeStatuses = [OmsOrderStatusType.NotScheduled, OmsOrderStatusType.Dispatched, OmsOrderStatusType.Scheduled];
    this.loadLimit = 20;
    this.selectedIds = [];
    this.omsOrdersRef = this.$omsOrder();

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTimeFiltersService.today(),
      statuses: [this.omsOrderStatusType.NotScheduled],
      queryString: undefined
    };

    this.filterConfig.settings = this.splitService.getSiteOmsSettings();

    this.omsOrdersRef.$query(this._qetQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.omsOrdersRef, this.loadLimit);
  };

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-md');
  };

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._query();
  }

  onSelectStatuses(statuses) {
    this.filterConfig.statuses = statuses;
    this._query();
  }

  onAssign(orderId, $event) {
    this.omsDialogService.assignOrder(orderId, $event)
      .then((supplier) => {
        this._assignToSupplier(orderId, supplier);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
      this.filterConfig.range = range;
      this._query();
    }
  }

  onGroupChanged(group) {
    this.filterConfig.group = group;
    this._query();
  }

  selectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  onSelectOrdersChanged(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    // this.selectedOrders = this.orders?.filter(o => !!this.selectedIds?.includes(o.id))
    this.excludeMode = excludeMode;
  }

  // ******************************
  //        Internal methods
  // ******************************

  private _query() {
    this.selectedIds = [];
    this.omsOrdersRef.$query(this._qetQueryPayload()).then(() => {
      this.infiniteScroll.reload();
    }, (resp) => {
      this.$log.debug('Fail to $query', resp);
    });
  }

  private _qetQueryPayload() {
    return {
      agentAccountIds: this.isDemand ? undefined : [this.account.id],
      accountIds: this.isDemand ? [this.account.id] : undefined,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      status: this.filterConfig.statuses,
      // partiallyScheduled: this.filterConfig.status === 'PartiallyScheduled',
      filterByCreatedAt: this.filterConfig.settings.filterByCreatedAt,
      query: this.filterConfig.queryString,
      limit: this.loadLimit
    };
  }

  private _assignToSupplier(orderId, supplier) {
    this.omsService.assignToSupplier(orderId, supplier)
      .then((res) => {
      })
      .catch((error) => {
        this.$log.error('Failed to assign an order to supplier', error);
      })
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountActiveOrders', {
    bindings: {
      account: '<',
      isDemand: '<'
    },
    template: require('./account-active-orders.html').default,
    controller: AccountActiveOrdersComponent
  });
